module.exports = __webpack_public_path__ + "static/media/closeicon.f0a27b09.png";